export default "__VITE_ASSET__DYCr9kLA__"